import { useIntl } from '@grandvisionhq/state';

const useFacetLabel = ({ facet  })=>{
    const { getLabel  } = useIntl();
    var _label;
    return (_label = facet.label) !== null && _label !== void 0 ? _label : getLabel(facet.labelKey || facet.id);
};

export { useFacetLabel };
//# sourceMappingURL=use-facet-label.js.map
